let param;
if (process.env.REACT_APP_IS_CLIENT) {
  param = require('./utils/url').param;
} else {
  param = require('querystring').stringify;
}

const ensureSlash = str => str[str.length - 1] === '/' ? str : `${str}/`;

export default ({base, locale = 'en', company, ...params}) => {
  const search = param(params);

  const path = `${ensureSlash(base)}${locale}/embed/book/${company}/`;

  if (search) {
    return `${path}?${search}`;
  }

  return path;
};



// WEBPACK FOOTER //
// ./src/partners/embed/createBookUrl.js